import React, { Component } from "react"
import { Accordion, Card, FormControl, OverlayTrigger, Popover, Tooltip } from "react-bootstrap"
import Select from "react-select"
import DatePicker from "../../../../../../components/common/DatePicker"
import moment from "moment"
import reggie from "../../../../../../utilities/Reggie"
import EmployeeDataTypes from "../../../../Types/EmployeeTypes"
import ReferenceTypes from "../../../../Types/ReferenceTypes"
import MsalAuth from "src/utilities/msalAuth"
import UserSettings from "src/utilities/UserSettings"
import TrashCan from "src/pages/dynamic_forms/Utils/TrashCan/TrashCan"
import snackBar from "src/utilities/snackBar/SnackBar"
import isValidDomain from "src/utilities/isValidDomain"

interface CompanyInfoProps {
    employee: EmployeeDataTypes
    copy: EmployeeDataTypes
    reference: ReferenceTypes | any
    loading: boolean
    countMissing: Function
    handleChange: Function | any
    appendParams: Function
    setEventType: Function
    validEmail: boolean
    singleDetail?: string
    readonly: boolean
}

class CompanyInfo extends Component<CompanyInfoProps, { isPhoneValid: boolean, phoneErrorMessage: string }> {

    settings = MsalAuth.UserSettings() || { UserAdminCompanyInfoOpen: true }

    updateUserSettings = () => {
        let settings = MsalAuth.UserSettings() || {}
        settings.UserAdminCompanyInfoOpen = !this.settings.UserAdminCompanyInfoOpen
        UserSettings.update(settings)
    }

    getPTODescription = (id: number) => {
        let ref = this.props.reference.ptoPlans || null
        if (ref) {
            for (let i = 0; i < ref.length; i++) {
                if (id === ref[i].id) {
                    return ref[i].text
                }
            }
        }
        return "NA"
    }

    updatePTOAdminTable = (plan: string) => {
        let elem = document.getElementById("pto-admin-table-pto-plan")
        if (elem) {
            elem.innerHTML = plan
        }
    }  
    
    constructor(props: any) {
        super (props);
        this.state = {
            isPhoneValid: true,
            phoneErrorMessage: ''
        }
    }

    render() {

        let employee = this.props.employee
        let singleDetail = false
        if (this.props.singleDetail) {
            singleDetail = true
        }

        const readOnly = this.props.readonly
        const validDomains = this.props.reference.validDomains
        const validDomain = isValidDomain(employee.WorkEmail, validDomains)

        // console.log(this.props.reference)
        // console.log("employee:", employee)
        // console.log(isValidEmail)
        // console.log(validDomains)

        const MissingCompInfoPopover = (
            <Popover id="popover-basic">
                <Popover.Title as="h2">Please check the following fields:</Popover.Title>
                {this.props.countMissing(["EmployeeNumber", "JobTitle", "JobTitleEffectiveDate", "WorkEmail", "LocationCode", "LocationCodeEffectiveDate", "HomeProfitCenter", "ProfitCenterEffectiveDate", "PTOPlanId"]).map((item: string, index: number) =>
                    <div className="uac-missing-info-tooltip-text" key={`miss-comp-${index}`}>
                        <p className="uac-missing-info-tooltip-text-item-number">{`${index + 1}. `}</p>
                        <p className="uac-missing-info-tooltip-text-item">{item.replace(/([A-Z])/g, ' $1').trim()}</p>
                    </div>
                )}
                {!this.props.validEmail && <div className="uac-missing-info-tooltip-text">
                    <p id="uac-missing-info-tooltip-text-item-invalid-email">{`*. `}</p>
                    <p className="uac-missing-info-tooltip-text-item">Invalid Email</p>
                </div>}
            </Popover>
        )

        const ValidDomainPopover = (
            <Popover id="valid-domain-popover">
                <Popover.Title as="h2">
                    Valid domains are:
                </Popover.Title>
                <Popover.Content>
                    {this.props.reference.validDomains.map((d: { Domain: string }, i: number) =>
                        <p key={i}>{d.Domain}</p>
                    )}
                </Popover.Content>
            </Popover>
        )

        const validWorkPhonePopover = (
            <Popover id='valid-work-phone-popover'>
                <Popover.Title as='h2'>
                    {this.state.phoneErrorMessage.length > 0 ? this.state.phoneErrorMessage : 'Invalid phone number entered.' }
                </Popover.Title>
            </Popover>
        )

        const CompanyInfoTootlip = (text: string) => (
            <Tooltip id="uac-tool-tip">
                {text}
            </Tooltip>
        )                

        // const open = this.settings.UserAdminCompanyInfoOpen        

        return (
            <div className="UserAdminR2">
                {/* <Accordion defaultActiveKey={open ? "0" : "1"} id="user-admin-accordion" */}
                <Accordion defaultActiveKey="0" id="user-admin-accordion"
                    onClick={() => this.updateUserSettings()}
                >
                    <Card id="user-admin-card">
                        <Accordion.Toggle as={Card.Header} eventKey="0" >
                            {this.props.loading && <div id="user-admin-card-title">
                                <p>Company Information</p>
                            </div>}
                            <div className="MissingEmployeeInfoWrapper">
                                {!this.props.loading && this.props.countMissing(["EmployeeNumber", "JobTitle", "JobTitleEffectiveDate", "WorkEmail", "LocationCode", "LocationCodeEffectiveDate", "HomeProfitCenter", "ProfitCenterEffectiveDate"]).length === 0 && <div id="user-admin-card-title">
                                    <p>Company Information</p>
                                </div>}
                                {!this.props.loading && this.props.countMissing(["EmployeeNumber", "JobTitle", "JobTitleEffectiveDate", "WorkEmail", "LocationCode", "LocationCodeEffectiveDate", "HomeProfitCenter", "ProfitCenterEffectiveDate"]).length > 0 && <div id="user-admin-card-title-warning">
                                    <p>Company Information</p>
                                    <OverlayTrigger delay={{ show: 50, hide: 400 }} placement="right" overlay={MissingCompInfoPopover}>
                                        <div id="user-admin-card-title-warning-text">
                                            <span className="material-icons">warning</span>
                                            <p>({this.props.countMissing(["EmployeeNumber", "JobTitle", "JobTitleEffectiveDate", "WorkEmail", "LocationCode", "LocationCodeEffectiveDate", "HomeProfitCenter", "ProfitCenterEffectiveDate"]).length})</p>
                                        </div>
                                    </OverlayTrigger>
                                </div>}
                            </div>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                            <div id="uac-company-info">
                                <div id="uac-company-info-r1">
                                    <div className="FindField" id="uac-company-info-r1-c1">
                                        <div id="uac-company-info-uname">
                                            <div id="uac-filled-field"><p>Username</p></div>
                                            <FormControl onFocus={() => this.props.setEventType("UserName")}
                                                // disabled={true}
                                                disabled={this.props.loading || singleDetail || readOnly}
                                                placeholder={employee.UserName || "*NA*"}
                                                aria-describedby="basic-addon1"
                                                onChange={this.props.handleChange}
                                                value={employee.UserName || ""}
                                            />
                                        </div>
                                    </div>
                                    <div className="FindField" id="uac-company-info-r1-c2">
                                        <div id="uac-company-info-employee-number">
                                            {employee.EmployeeNumber && <div id="uac-filled-field"><p>Employee Number{!readOnly && <span className="material-icons">done</span>}</p></div>}
                                            {!employee.EmployeeNumber && <div id="uac-missing-field"><p>Employee Number<span className="material-icons">warning</span></p></div>}
                                            <FormControl onFocus={() => this.props.setEventType("EmployeeNumber")}
                                                disabled={this.props.loading || singleDetail || readOnly}
                                                placeholder={employee.EmployeeNumber || "*NA*"}
                                                aria-describedby="basic-addon1"
                                                onChange={this.props.handleChange}
                                                value={employee.EmployeeNumber || ""}
                                            />
                                        </div>
                                    </div>
                                    <div className="FindField" id="uac-company-info-r1-c3">
                                        <div id="uac-company-info-job-title">
                                            <div id="uac-company-info-job-title-header">
                                                <div id="uac-company-info-job-title-header-left">
                                                    {employee.JobTitle && <div id="uac-filled-field"><p>Job Title{!readOnly && <span className="material-icons">done</span>}</p></div>}
                                                    {!employee.JobTitle && <div id="uac-missing-field"><p>Job Title<span className="material-icons">warning</span></p></div>}
                                                </div>
                                                <div id="uac-company-info-job-title-header-right">
                                                    <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={CompanyInfoTootlip("Edit")}>
                                                        <div id="uac-effective-date-edit">{!readOnly && <span className="material-icons" onClick={() => this.props.setEventType("JobTitleEffectiveDate")}>edit</span>}</div>
                                                    </OverlayTrigger>
                                                    {employee.JobTitleEffectiveDate && <div id="uac-effective-date-available">
                                                        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={CompanyInfoTootlip(`Effective Date: ${moment(employee.JobTitleEffectiveDate).format("MMM Do YYYY")}`)}>
                                                            <span className="material-icons">event</span>
                                                        </OverlayTrigger>
                                                    </div>}
                                                    {!employee.JobTitleEffectiveDate && <div id="uac-effective-date-missing">
                                                        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={CompanyInfoTootlip("*NA*")}>
                                                            <span className="material-icons">event</span>
                                                        </OverlayTrigger>
                                                    </div>}
                                                </div>
                                            </div>
                                            {this.props.reference.jobTitles && <Select
                                                id=""
                                                isDisabled={this.props.loading || singleDetail || readOnly}
                                                value={{ label: employee.JobTitle || "*NA*" }}
                                                options={this.props.reference.jobTitles.map((s: any) => ({ value: s.id, label: s.text }))}
                                                onChange={(item: any) => {
                                                    if (item.label !== this.props.copy.JobTitle) {
                                                        const d = moment().format().split("T")[0]
                                                        this.props.appendParams([
                                                            { JobTitle: item.label },
                                                            { JobTitleId: item.value },
                                                            { JobTitleEffectiveDate: d },
                                                            { JobTitleEffectiveDateId: null },
                                                        ])
                                                        snackBar({ text: `Effective: ${d}`, type: "plain", timeout: 3000 })
                                                    } else {
                                                        this.props.appendParams([
                                                            { JobTitle: item.label },
                                                            { JobTitleId: item.value },
                                                            { JobTitleEffectiveDate: this.props.copy.JobTitleEffectiveDate },
                                                            { JobTitleEffectiveDateId: this.props.copy.JobTitleEffectiveDateId }
                                                        ])
                                                    }
                                                }}
                                                maxMenuHeight={150}
                                            />}
                                        </div>
                                    </div>
                                </div>
                                <div id="uac-company-info-r2">
                                    <div className="FindField" id="uac-company-info-r2-c1">
                                        <div id="uac-company-info-work-phone">
                                            {this.state.isPhoneValid && <div id="uac-filled-field"><p>Work Phone</p></div>}
                                            {!this.state.isPhoneValid &&
                                                <div id="uac-missing-field"><p>Work Phone
                                                    <OverlayTrigger placement="right" overlay={validWorkPhonePopover}>
                                                        <span className="material-icons BadEmailOrDomainWarningIcon">warning</span>
                                                    </OverlayTrigger>
                                                </p></div>
                                            }
                                            <FormControl onFocus={() => { this.props.setEventType("WorkPhone"); this.setState({ isPhoneValid: true, phoneErrorMessage: '' }); }}
                                                disabled={this.props.loading || singleDetail || readOnly}
                                                placeholder={employee.WorkPhone || "*NA*"}
                                                aria-describedby="basic-addon1"
                                                onChange={this.props.handleChange}
                                                onKeyDownCapture={(e: React.KeyboardEvent<HTMLInputElement>) => {                                                
                                                    const validInputRegex = /[0-9]|\(|\)| |-|\+|[\b]/g;
                                                    const allowedActionKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'End', 'Home', 'Delete', 'Tab'];

                                                    if (validInputRegex.test(e.key) || allowedActionKeys.includes(e.key)) return;                                                    
                                                    e.preventDefault();                                         
                                                }}
                                                maxLength={17}                                        
                                                onPasteCapture={(event: React.ClipboardEvent<HTMLInputElement>) => {
                                                    const invalidRegex = /[a-zA-Z!@#$%^&*_=,\./:;'"\[{}\]<>?\|\\]/g;
                                                    if (invalidRegex.test(event.clipboardData.getData('Text'))) {
                                                        this.setState({ isPhoneValid: false, phoneErrorMessage: 'Cannot paste invalid values.'});
                                                        event.preventDefault();
                                                    }
                                                }}
                                                onBlurCapture={(event: React.FocusEvent<HTMLInputElement>) => {
                                                    if (event.target.value == null || event.target.value.length === 0) {
                                                        this.setState({ isPhoneValid: true });
                                                        return;
                                                    }

                                                    const regex = /[a-zA-Z!@#$%^&*_=,\./:;'"\[{}\]<>?\|\\]/g;
                                                    if (regex.test(event.target.value)) {
                                                        this.setState({ isPhoneValid: false, phoneErrorMessage: 'Invalid work phone.' });
                                                        return;
                                                    }

                                                    const onlyDigits = ('' + event.target.value).replace(/\D/g, '');
                                                    if (onlyDigits.length < 10 || onlyDigits.length > 11) {
                                                        this.setState({ isPhoneValid: false, phoneErrorMessage: 'Invalid work phone.' });
                                                        return;
                                                    }

                                                    this.setState({ isPhoneValid: true });
                                                }}
                                                //@ts-ignore
                                                value={employee.WorkPhone}
                                            />
                                        </div>
                                    </div>
                                    <div className="FindField" id="uac-company-info-r2-c2">
                                        <div id="uac-company-info-email">
                                            {employee.WorkEmail && (validDomain && this.props.validEmail) && <div id="uac-filled-field"><p>Work Email{!readOnly && <span className="material-icons">done</span>}</p></div>}
                                            {employee.WorkEmail && !(validDomain && this.props.validEmail) &&
                                                <div id="uac-missing-field"><p>Invalid Work Email
                                                    <OverlayTrigger placement="right" overlay={ValidDomainPopover}>
                                                        <span className="material-icons BadEmailOrDomainWarningIcon" >warning</span>
                                                    </OverlayTrigger>
                                                </p></div>}
                                            {!employee.WorkEmail && <div id="uac-missing-field"><p>Work Email<span className="material-icons">warning</span></p></div>}
                                            <FormControl onFocus={() => this.props.setEventType("WorkEmail")}
                                                disabled={this.props.loading || singleDetail || readOnly}
                                                placeholder={employee.WorkEmail || "*NA*"}
                                                aria-describedby="basic-addon1"
                                                onChange={this.props.handleChange}
                                                value={employee.WorkEmail || ""}
                                            />
                                        </div>
                                    </div>
                                    <div className="FindField" id="uac-company-info-r2-c3">
                                        <div id="uac-company-info-location-code">
                                            <div id="uac-company-info-loc-code-header">
                                                <div id="uac-company-info-loc-code-header-left">
                                                    {employee.LocationCode && <div id="uac-filled-field"><p>Location Code{!readOnly && <span className="material-icons">done</span>}</p></div>}
                                                    {!employee.LocationCode && <div id="uac-missing-field"><p>Location Code<span className="material-icons">warning</span></p></div>}
                                                </div>
                                                <div id="uac-company-info-loc-code-header-right">
                                                    <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={CompanyInfoTootlip("Edit")}>
                                                        <div id="uac-effective-date-edit">{!readOnly && <span className="material-icons" onClick={() => this.props.setEventType("LocationCodeEffectiveDate")}>edit</span>}</div>
                                                    </OverlayTrigger>
                                                    {employee.LocationCodeEffectiveDate && <div id="uac-effective-date-available">
                                                        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={CompanyInfoTootlip(`Effective Date: ${moment(employee.LocationCodeEffectiveDate).format("MMM Do YYYY")}`)}>
                                                            <span className="material-icons">event</span>
                                                        </OverlayTrigger>
                                                    </div>}
                                                    {!employee.LocationCodeEffectiveDate && <div id="uac-effective-date-missing">
                                                        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={CompanyInfoTootlip("*NA*")}>
                                                            <span className="material-icons">event</span>
                                                        </OverlayTrigger>
                                                    </div>}
                                                </div>
                                            </div>
                                            {this.props.reference.locationCodes && <Select
                                                isDisabled={this.props.loading || singleDetail || readOnly}
                                                value={{ label: employee.LocationCode || "*NA*" }}
                                                options={this.props.reference.locationCodes.map((s: any) => ({ value: s.id, label: s.text }))}
                                                onChange={(item: any) => {
                                                    if (item.label !== this.props.copy.LocationCode) {
                                                        const d = moment().format().split("T")[0]
                                                        this.props.appendParams([
                                                            { LocationCode: item.label },
                                                            { LocationCodeEffectiveDate: d },
                                                            { LocationCodeEffectiveDateId: null }
                                                        ])
                                                        snackBar({ text: `Effective: ${d}`, type: "plain", timeout: 3000 })
                                                    } else {
                                                        this.props.appendParams([
                                                            { LocationCode: item.label },
                                                            { LocationCodeEffectiveDate: this.props.copy.LocationCodeEffectiveDate },
                                                            { LocationCodeEffectiveDateId: this.props.copy.LocationCodeEffectiveDateId }
                                                        ])
                                                    }
                                                }}
                                                menuPlacement="bottom"
                                                maxMenuHeight={100}
                                            />}
                                        </div>
                                    </div>
                                </div>
                                <div id="uac-company-info-r3">
                                    {/* <div className="FindField" id="uac-company-info-r3-c1">
                                        <div id="uac-company-info-loc-code">
                                            <div id="uac-company-info-loc-code-header">
                                                <div id="uac-company-info-loc-code-header-left">
                                                    {employee.LocationCode && <div id="uac-filled-field"><p>Location Code{!readOnly && <span className="material-icons">done</span>}</p></div>}
                                                    {!employee.LocationCode && <div id="uac-missing-field"><p>Location Code<span className="material-icons">warning</span></p></div>}
                                                </div>
                                                <div id="uac-company-info-loc-code-header-right">
                                                    <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={CompanyInfoTootlip("Edit")}>
                                                        <div id="uac-effective-date-edit">{!readOnly && <span className="material-icons" onClick={() => this.props.setEventType("LocationCodeEffectiveDate")}>edit</span>}</div>
                                                    </OverlayTrigger>
                                                    {employee.LocationCodeEffectiveDate && <div id="uac-effective-date-available">
                                                        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={LocationCodeEffectiveToolTip}>
                                                            <span className="material-icons">event</span>
                                                        </OverlayTrigger>
                                                    </div>}
                                                    {!employee.LocationCodeEffectiveDate && <div id="uac-effective-date-missing">
                                                        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={LocationCodeEffectiveToolTip}>
                                                            <span className="material-icons">event</span>
                                                        </OverlayTrigger>
                                                    </div>}
                                                </div>
                                            </div>
                                            <FormControl onFocus={() => this.props.setEventType("LocationCode")}
                                                disabled={this.props.loading || singleDetail || readOnly}
                                                placeholder={employee.LocationCode || "*NA*"}
                                                aria-describedby="basic-addon1"
                                                onChange={this.props.handleChange}
                                                value={employee.LocationCode || ""}
                                            />
                                        </div>
                                    </div> */}
                                    <div className="FindField" id="uac-company-info-r3-c1">
                                        <div id="uac-company-info-home-occupation-type">
                                            <div id="uac-filled-field"><p>Occupation Type</p></div>
                                            {this.props.reference.occupationTypes && <Select
                                                isDisabled={this.props.loading || singleDetail || readOnly}
                                                value={{ label: employee.OccupationTypeDesc || "*NA*" }}
                                                options={this.props.reference.occupationTypes.map((s: any) => ({ value: s.id, label: s.text }))}
                                                onChange={(item: any) => {
                                                    this.props.appendParams([{ OccupationTypeDesc: item.label }, { OccupationTypeId: item.value }])
                                                }}
                                                menuPlacement="top"
                                                maxMenuHeight={150}
                                            />}
                                        </div>
                                    </div>
                                    <div className="FindField" id="uac-company-info-r3-c2">
                                        <div id="uac-company-info-home-dept">
                                            <div id="uac-company-info-home-dept-header">
                                                <p>Home Department</p>
                                                {employee.HomeDepartmentDifferentThanProfitCenter && <OverlayTrigger placement="top" overlay={CompanyInfoTootlip("Home department is outside of the home profit center.")}>
                                                    <span id="uac-warning-field" className="material-icons HomeDepartmentAndHomeProfitCenterMismatch">warning</span>
                                                </OverlayTrigger>}
                                            </div>
                                            {this.props.reference.departments && <Select
                                                isDisabled={this.props.loading || singleDetail || readOnly}
                                                value={{ label: employee.HomeDepartment || "*NA*" }}
                                                options={this.props.reference.departments.map((s: any) => ({ value: s.id, label: s.text }))}
                                                onChange={(item: any) => {
                                                    this.props.appendParams([{ HomeDepartment: item.label }, { DepartmentId: item.value }, { HomeDepartmentDifferentThanProfitCenter: false }])
                                                }}
                                                menuPlacement="top"
                                                maxMenuHeight={150}
                                            />}
                                        </div>
                                    </div>
                                    <div className="FindField" id="uac-company-info-r3-c3">
                                        <div id="uac-company-info-home-prof">
                                            <div id="uac-company-info-home-prof-header">
                                                <div id="uac-company-info-home-prof-header-left">
                                                    {employee.HomeProfitCenter && <div id="uac-filled-field"><p>Home Profit Center{!readOnly && <span className="material-icons">done</span>}</p></div>}
                                                    {!employee.HomeProfitCenter && <div id="uac-missing-field"><p>Home Profit Center<span className="material-icons">warning</span></p></div>}
                                                </div>
                                                <div id="uac-company-info-home-prof-header-right">
                                                    <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={CompanyInfoTootlip("Edit")}>
                                                        <div id="uac-effective-date-edit">{!readOnly && <span className="material-icons" onClick={() => this.props.setEventType("ProfitCenterEffectiveDate")}>edit</span>}</div>
                                                    </OverlayTrigger>
                                                    {employee.ProfitCenterEffectiveDate && <div id="uac-effective-date-available">
                                                        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={CompanyInfoTootlip(`Effective Date: ${moment(employee.ProfitCenterEffectiveDate).format("MMM Do YYYY")}`)}>
                                                            <span className="material-icons">event</span>
                                                        </OverlayTrigger>
                                                    </div>}
                                                    {!employee.ProfitCenterEffectiveDate && <div id="uac-effective-date-missing">
                                                        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={CompanyInfoTootlip("*NA*")}>
                                                            <span className="material-icons">event</span>
                                                        </OverlayTrigger>
                                                    </div>}
                                                </div>
                                            </div>
                                            {this.props.reference.profitCenters && <Select
                                                id=""
                                                isDisabled={this.props.loading || singleDetail || readOnly}
                                                value={{ label: employee.HomeProfitCenter || "*NA*" }}
                                                options={this.props.reference.profitCenters.map((s: any) => ({ value: s.id, label: s.shortText }))}
                                                onChange={(item: any) => {
                                                    if (item.value !== this.props.copy.HomeProfitCenterId) {
                                                        const d = moment().format().split("T")[0]
                                                        this.props.appendParams([
                                                            { HomeProfitCenter: item.label },
                                                            { HomeProfitCenterId: item.value },
                                                            { ProfitCenterEffectiveDate: d },
                                                            { ProfitCenterEffectiveDateId: null }
                                                        ])
                                                        snackBar({ text: `Effective: ${d}`, type: "plain", timeout: 3000 })
                                                    } else {
                                                        this.props.appendParams([
                                                            { HomeProfitCenter: item.label },
                                                            { HomeProfitCenterId: item.value },
                                                            { ProfitCenterEffectiveDate: this.props.copy.ProfitCenterEffectiveDate },
                                                            { ProfitCenterEffectiveDateId: this.props.copy.ProfitCenterEffectiveDateId }
                                                        ])
                                                    }
                                                }}
                                                menuPlacement="top"
                                                maxMenuHeight={175}
                                            />}
                                        </div>
                                    </div>
                                </div>
                                <div id="uac-company-info-r4">
                                    <div className="FindField" id="uac-company-info-r4-c1">
                                        <div id="uac-company-info-working-prof-center">
                                            <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={CompanyInfoTootlip("Add additional areas through LaunchPoint web site User Administration page.")}>
                                                <div id="working-prof-center-header"><p>Working Profit Center</p>{!readOnly && <span className="material-icons">help</span>}</div>
                                            </OverlayTrigger>
                                            {employee.WorkingProfitCentersAllowed &&
                                                <Select
                                                    isDisabled={this.props.loading || singleDetail || readOnly}
                                                    //@ts-ignore
                                                    value={{ label: employee.WorkingProfitCenter || "*NA*" }}
                                                    options={employee.WorkingProfitCentersAllowed.map((s: any) => ({ value: s.id, label: s.text }))}
                                                    onChange={(item: any) => {
                                                        this.props.appendParams([{ WorkingProfitCenter: item.label }, { WorkingProfitCenterId: item.value }])
                                                    }}
                                                    menuPlacement="top"
                                                    maxMenuHeight={200}
                                                />}
                                        </div>
                                    </div>
                                    <div className="FindField" id="uac-company-info-r4-c2">
                                        <div id="uac-company-info-pto-pln">
                                            {employee.PTOPlanId && <div id="uac-filled-field"><p>PTO Plan{!readOnly && <span className="material-icons">done</span>}</p></div>}
                                            {!employee.PTOPlanId && <div id="uac-missing-field"><p>PTO Plan<span className="material-icons">warning</span></p></div>}
                                            <Select
                                                isDisabled={this.props.loading || singleDetail || readOnly}
                                                //@ts-ignore
                                                value={{ label: this.getPTODescription(employee.PTOPlanId) }}
                                                options={this.props.reference.ptoPlans.map((s: any) => ({ value: s.id, label: s.text }))}
                                                onChange={(item: any) => {
                                                    this.props.appendParams([{ PTOPlanId: item.value }])
                                                    this.updatePTOAdminTable(item.label);
                                                }}
                                                menuPlacement="top"
                                                maxMenuHeight={200}
                                            />
                                        </div>
                                    </div>
                                    <div className="FindField" id="uac-company-info-r4-c3">
                                        <div id="uac-company-info-last-boots">
                                            <div id="uac-filled-field"><p>Last Boot Replacement</p></div>
                                            <div className="UserAdminHasTrashCan">
                                                <DatePicker
                                                    onChange={(date: any) => {
                                                        if (!singleDetail) {
                                                            this.props.appendParams([{ LastBootReplacement: moment(date.valueOf()).format().split("T")[0] }])
                                                        }
                                                    }}
                                                    value={employee.LastBootReplacement}
                                                    useCloseCallback={true}
                                                    disabled={this.props.loading || singleDetail || readOnly}
                                                />
                                                {employee.LastBootReplacement && (!singleDetail && !readOnly && !this.props.loading) && <div className="UserAdminDateNuller">
                                                    <TrashCan color="#000000" clickCallback={() => this.props.appendParams([{ LastBootReplacement: null }])} />
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </div>
        )
    }
}

export default CompanyInfo